import serverVars from 'server-vars';
import { trackEvent, eventNameConstants } from 'dibs-tracking';
import { getAbUuid } from 'dibs-cookie-jar/exports/abTestHelpers';

import type { AbTestV2 } from '../../server/types/dblRouteHandlerArgs';

export function getAbTestV2(testName: string): AbTestV2 | null {
    if (typeof window === 'undefined') {
        throw new Error('getAbTestV2 should only be called on the client!');
    }
    return serverVars.get('abTestsV2.' + testName) || null;
}

export function trackAbTestV2Variant(testName: string): void {
    const abTest = getAbTestV2(testName);
    if (abTest) {
        trackEvent({
            category: 'a/b testing v3',
            eventName: eventNameConstants.EVENT_AB_TESTING,
            action: testName,
            interaction_type: testName,
            label: abTest.variant,
            step_interaction_name: abTest.variant,
            value: abTest.config.ramp || undefined,
            ab_uuidCookie: getAbUuid(document.cookie),
        });
    }
}
